import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import { LoadingDataState } from "altus-datastate";
import { RouteContainer, LoadingOverlay } from "altus-ui-components";

import { employeeContainerOnLoad } from "features/planner/employee/employee.actions";
import { getEmployeeCardFromState } from "features/planner/employee/employee.selectors";
import EmployeeHiddenWarning from "features/planner/employee/components/EmployeeHiddenWarning";
import EmployeeEarliestNextDeploymentWarning from "features/planner/employee/components/EmployeeEarliestNextDeploymentWarning";

class EmployeeContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad, employeeCardId } = this.props;

    dispatchOnLoad(employeeCardId);
  }

  render() {
    const { employeeCard, routes } = this.props;

    return (
      <>
        {employeeCard && (
          <>
            <EmployeeHiddenWarning employee={employeeCard.get("employee")} />
            <EmployeeEarliestNextDeploymentWarning
              employee={employeeCard.get("employee")}
            />
          </>
        )}
        {!employeeCard && <LoadingOverlay dataState={LoadingDataState} />}
        {employeeCard && <RouteContainer routes={routes} />}
      </>
    );
  }
}

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      employeeCard: getEmployeeCardFromState(state, employeeCardId),
    }),
    {
      dispatchOnLoad: employeeContainerOnLoad,
    },
  ),
)(EmployeeContainer);
